import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import PublicLayout from "../components/PublicLayout";

export default function Login() {
  const [params] = useSearchParams();
  const next = params.get("next") || "";

  const googleLogin = () => {
    const API = process.env.REACT_APP_BACKEND_URL;
    const url = `${API}/api/auth/google/login${next ? `?next=${encodeURIComponent(next)}` : ""}`;
    window.location.href = url;
  };

  return (
    <PublicLayout>
      <section className="max-w-5xl mx-auto px-6 md:px-10 py-16 grid md:grid-cols-2 gap-16 items-center">
        <div>
          <div className="bb-overline text-[var(--bb-terracotta)] mb-3">SIGN IN</div>
          <h1 className="font-serif text-5xl md:text-6xl text-[var(--bb-forest)] tracking-tight leading-[1.05]">Welcome.</h1>
          <p className="mt-5 text-[var(--bb-ink)]/75 max-w-md">Donors and schools sign in with Google — one click, no password to remember.</p>

          <div className="mt-10 bb-card p-8">
            <div className="text-center">
              <p className="text-sm text-[var(--bb-ink)]/80 mb-6">Choose your role after signing in.</p>
              <button onClick={googleLogin} className="bb-btn-primary w-full inline-flex items-center justify-center gap-3" data-testid="google-login">
                <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#fff" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#fff" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#fff" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/></svg>
                Continue with Google
              </button>
              <div className="mt-6 text-xs text-[var(--bb-muted)]">
                Running a school? After signing in, <Link to="/register-school" className="bb-link">create your school profile</Link>.
              </div>
            </div>
          </div>
        </div>
        <div className="hidden md:block">
          <div className="aspect-[3/4] rounded-md overflow-hidden border border-[var(--bb-border)]">
            <img src="https://images.unsplash.com/photo-1692269726203-fa0d613eec37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBydXJhbCUyMHNjaG9vbCUyMGNoaWxkcmVuJTIwc21pbGluZ3xlbnwwfHx8fDE3NzY3NTIwOTh8MA&ixlib=rb-4.1.0&q=85" alt="School children" className="w-full h-full object-cover"/>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
